const SECOND = 1000
const MINUTE = 60 * SECOND

export const pollingIntervals = {
  ping: 5 * SECOND,
  duoAuthEnrollAccount: SECOND,
  customerJobsRefetch: 5 * SECOND,
  jobsShowRefetch: 10 * SECOND,
  horizontalOverflowScroll: SECOND,
  lockRefreshTime: 20 * SECOND,
  lockCheckTime: 10 * SECOND,
  intervalTime:
    process.env.NODE_ENV === "development"
      ? 60 * SECOND
      : process.env.NODE_ENV === "test"
      ? SECOND
      : 120 * SECOND,
  jobsIndexRefetch: 10 * SECOND,
  orderRequestsIndexRefetch: 5 * MINUTE,
  settingsRefetch: 5 * 60 * SECOND,
  sagePCPoll: SECOND,
  sagePCTimeout: 30 * SECOND,
  versionCheck: 120 * SECOND,
  sageImportStatus: 5 * SECOND,
  checkFor365User: 5 * SECOND,
  thirtySeconds: 30 * SECOND,
  oneMinute: 60 * SECOND,
} as const
